import { useEffect } from 'react';

// Hook for managing page SEO metadata

export const usePageMeta = (title, description) => {
  useEffect(() => {
    // Set page title
    document.title = title;

    // Set or update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    } else {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      metaDescription.content = description;
      document.head.appendChild(metaDescription);
    }

    // Scroll to top on page change
    window.scrollTo(0, 0);
  }, [title, description]);
};
